module.exports = __webpack_public_path__ + "static/img/heart.f57f0f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/heart.png
// module id = V4Uf
// module chunks = 1